const enum DocsEngineReferenceEvent {
  OpenTypeTooltip = 'DocsEngineReferenceEvent_OpenTypeTooltip',
  OpenTagTooltip = 'DocsEngineReferenceEvent_OpenTagTooltip',
}

export default DocsEngineReferenceEvent;
